import React from 'react';
import { NavLink, Outlet, useNavigate, Link } from 'react-router-dom';
import { Home, PlusCircle, UserCog, LogOut, ShieldCheck, Phone } from 'lucide-react';
import { useAuth } from '../AuthContext';
import { useNoIndex } from '../ProtectedRoute';

const navItems = [
  { to: '/espace-client', end: true, icon: Home, label: 'Mes demandes', testid: 'client-nav-home' },
  { to: '/espace-client/nouvelle-demande', icon: PlusCircle, label: 'Nouvelle demande', testid: 'client-nav-new' },
  { to: '/espace-client/compte', icon: UserCog, label: 'Mon compte', testid: 'client-nav-account' },
];

const ClientLayout = () => {
  useNoIndex();
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const handleLogout = () => { logout(); navigate('/connexion', { replace: true }); };

  return (
    <div className="min-h-screen bg-neutral-50">
      <header className="bg-white border-b border-neutral-200 sticky top-0 z-20">
        <div className="max-w-5xl mx-auto px-4 h-16 flex items-center justify-between">
          <Link to="/espace-client" className="flex items-center gap-2">
            <div className="w-9 h-9 rounded-lg bg-red-700 flex items-center justify-center">
              <ShieldCheck className="w-5 h-5 text-white" />
            </div>
            <div className="leading-tight">
              <p className="font-bold text-neutral-900">Espace Client</p>
              <p className="text-xs text-neutral-500">EMS Express</p>
            </div>
          </Link>
          <div className="flex items-center gap-3">
            <a href="tel:0764084510" className="hidden sm:flex items-center gap-1.5 text-sm text-red-700 font-semibold" data-testid="client-call-link">
              <Phone className="w-4 h-4" /> 07 64 08 45 10
            </a>
            <button onClick={handleLogout} data-testid="client-logout-button"
              className="flex items-center gap-1.5 text-sm text-neutral-500 hover:text-red-700 transition-colors">
              <LogOut className="w-4 h-4" /> <span className="hidden sm:inline">Déconnexion</span>
            </button>
          </div>
        </div>
        <nav className="max-w-5xl mx-auto px-4 flex gap-1 overflow-x-auto">
          {navItems.map((item) => (
            <NavLink key={item.to} to={item.to} end={item.end} data-testid={item.testid}
              className={({ isActive }) =>
                `flex items-center gap-2 px-3 py-3 text-sm font-medium border-b-2 whitespace-nowrap transition-colors ${
                  isActive ? 'border-red-700 text-red-700' : 'border-transparent text-neutral-500 hover:text-neutral-900'
                }`
              }>
              <item.icon className="w-4 h-4" /> {item.label}
            </NavLink>
          ))}
        </nav>
      </header>
      <main className="max-w-5xl mx-auto px-4 py-6">
        <div className="mb-4">
          <p className="text-sm text-neutral-500">Bonjour,</p>
          <p className="text-lg font-bold text-neutral-900">{user?.name}</p>
        </div>
        <Outlet />
      </main>
    </div>
  );
};

export default ClientLayout;
